import { api } from ".";

const basePath = "/tag";

// `custom` (serbest etiket) 24 Ağu'da kaldırıldı: `skill` ile birebir aynı
// davranıyordu, tek farkı paneldeki sekme başlığıydı.
export type TagKind = "role" | "skill";

export const createTag = async ({
  name,
  kind,
  description,
  color,
  relatedTagIds,
}: any) => {
  try {
    const res = await api.post(`${basePath}`, {
      name,
      kind,
      description,
      color,
      relatedTagIds,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const updateTagById = async ({ id, updates }: any) => {
  try {
    const res = await api.put(`${basePath}`, {
      _id: id,
      ...updates,
    });
    return res;
  } catch (error) {
    console.error("Rol / yetenek güncellenemedi:", error);
    return error;
  }
};

export const getTagList = async (params: Record<string, any> = {}) => {
  try {
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined)
    );
    const res = await api.get(`${basePath}/list`, { params: filteredParams });
    return res;
  } catch (error) {
    return error;
  }
};

export const deleteTag = async ({ id }: { id: string }) => {
  try {
    const res = await api.delete(`${basePath}`, {
      data: { _id: id },
    });
    return res;
  } catch (error) {
    return error;
  }
};

/** kind verilmezse şirketin tüm etiketleri döner. */
export const getTagSelectData = async (kind?: TagKind) => {
  try {
    const res = await api.get(`${basePath}/select-data`, {
      params: kind ? { kind } : undefined,
    });
    return res;
  } catch (error) {
    return error;
  }
};

export const getTagById = async ({ id }: any) => {
  try {
    const res = await api.get(`${basePath}`, { params: { _id: id } });
    return res;
  } catch (error) {
    return error;
  }
};
